import React from 'react';
import './CategoryPage.css';

function ReportsCategory({ onNavigate, onClose }) {
  return (
    <div className="category-page-container">
      <div className="category-page-header">
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <button onClick={onClose} className="back-button">
            {'\u2190'} Back to Dashboard
          </button>
          <button 
            onClick={onClose} 
            style={{
              background: '#4169E1',
              color: 'white',
              border: 'none',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              fontSize: '18px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ✕
          </button>
        </div>
        <div className="category-page-title">
          <span className="category-page-icon">{'\u{1F4CA}'}</span>
          <h1>Reports</h1>
        </div>
      </div>

      <div className="category-page-content">
        <div className="action-grid">

          <button className="action-card card-indigo" onClick={() => onNavigate('outstandingFees')}>
            <span className="action-icon">{'\u{1F4CA}'}</span>
            <span className="action-text">Outstanding Fees Report</span>
          </button>

          <button className="action-card card-green" onClick={() => onNavigate('incomeFeesReport')}>
            <span className="action-icon">{'\u{1F4B0}'}</span>
            <span className="action-text">Income Fees Report</span>
          </button>

          <button className="action-card card-orange" onClick={() => onNavigate('outstandingAdminFees')}>
            <span className="action-icon">{'\u{1F4CB}'}</span>
            <span className="action-text">Outstanding Admin Fees</span>
          </button>

          <button className="action-card card-purple" onClick={() => onNavigate('emailLog')}>
            <span className="action-icon">📧</span>
            <span className="action-text">Email Delivery Log</span>
          </button>

          {/* T-Shirt Reconciliation Report */}
          <button className="action-card card-teal" onClick={() => onNavigate('tshirtRecon')}>
            <span className="action-icon">👕</span>
            <span className="action-text">T-Shirt Order Reconciliation</span>
          </button>

          {/* School Commission Report */}
          <button className="action-card card-green" onClick={() => onNavigate('schoolCommissionReport')}>
            <span className="action-icon">🏫</span>
            <span className="action-text">School Commission Report</span>
          </button>

        </div>
      </div>
    </div>
  );
}

export default ReportsCategory;